'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _each = require('lodash/each');

var _each2 = _interopRequireDefault(_each);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	buildQueryHash: function buildQueryHash(url) {
		var queryHash = {};
		url = url || window.location.href;
		var query = url.split('?')[1];
		if (query) {
			var parts = query.split('&');
			(0, _each2.default)(parts, function (part) {
				var namevalue = part.split('=');
				queryHash[decodeURIComponent(namevalue[0])] = decodeURIComponent(namevalue[1]);
			});
		}
		return queryHash;
	}
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/QueryUtils.js
// module id = 433
// module chunks = 0